// What every view of a quote derives from its documents the same way: the
// timeline, terms and the value model (whose launch month the timeline sets).
import { goLiveMonthsOf, readTerms, readTimeline } from './terms.ts';
import { readValueModel, type ValueModel } from './valueModel.ts';

/** The quote's documents as the builder loads them (QuoteBuilder in the UI). */
export interface QuoteDocumentsData {
  quote: { timeline?: unknown; proposal?: unknown; value_model?: unknown; account_name: string };
}

export function deriveWorkspace(data: QuoteDocumentsData) {
  const { quote } = data;
  const timeline = readTimeline(quote.timeline);
  const terms = readTerms(quote.proposal, quote.account_name);
  const stored = readValueModel(quote.value_model);
  const timelineGoLive = goLiveMonthsOf(timeline);
  const valueModel: ValueModel = timelineGoLive === null ? stored : { ...stored, goLiveMonths: timelineGoLive };
  return { timeline, terms, valueModel, timelineGoLive };
}
